const kerken = [
  {
    name: 'Gotische Kathedraal',
    description: [
      'Een gedetailleerd 3D-model van een gotische kathedraal.',
      'Vraag gerust naar maatwerk of andere kerken!'
    ],
    dimensions: '70x50x100mm',
    images: [
      require('../../images/kerken/Kerk_1A.png'),
      // require('../../images/kerken/Kerk_1B.png'), // voeg meer toe indien beschikbaar
    ],
    stl: '/products/kerken/voorbeeld-kerk.stl',
    contactLink: '/contact?product=Gotische%20Kathedraal',
    price: '29,99',
  },
  // Voeg hier meer kerken toe
];

export default kerken; 